module.exports = __webpack_public_path__ + "static/media/Sec-4_Banner_VN_Mobile.98f1d0a1.webp";